import classnames from 'classnames'
import {css} from 'emotion'
import * as React from 'react'
import {Component} from 'react'
import {px} from '~/components/utils'
import styles from './styles.module.css'

interface IProps {
  className?: string
  darkBackground?: boolean
  sizePx?: number // defaults to 25px. This roughly sets the width/height, though it's a bit larger than this.
}

export default class LoadingSpinner extends Component<IProps> {
  render() {
    const sizePx = px(this.props.sizePx ?? 25)
    return (
      <div
        className={classnames(
          styles['loader'],
          styles['default-style'],
          css`
            &,
            &:after {
              width: ${sizePx};
              height: ${sizePx};
            }
          `,
          this.props.darkBackground && styles['dark-bg-style'],
          this.props.className
        )}
      />
    )
  }
}
